export default __webpack_public_path__ + "static/media/(25).e98ef87f.jpg";